import { render, staticRenderFns } from "./TotalSalaryReport.vue?vue&type=template&id=e9c7bd1a&"
import script from "./TotalSalaryReport.vue?vue&type=script&lang=js&"
export * from "./TotalSalaryReport.vue?vue&type=script&lang=js&"
import style0 from "./TotalSalaryReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports